import React, { FC } from 'react';

import { Channel } from 'client/model/skill';

interface Props {
    channel: Channel.AliceSkill | Channel.SmartHome;
}

export const SkillIcon: FC<Props> = ({ channel }) => (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1477_4171)">
            <path
                d="M93.5 48.4286C93.5 73.3208 73.3208 93.5 48.4286 93.5C23.6902 93.5 5.20052 73.4492 3.35043 48.2456C1.8862 28.2982 2.66303 11.232 3.10772 4.33184C3.15116 3.65789 3.65789 3.15116 4.33184 3.10772C11.232 2.66303 28.2982 1.8862 48.2456 3.35043C73.4492 5.20052 93.5 23.6902 93.5 48.4286Z"
                fill="url(#paint0_linear_1477_4171)"
                stroke="url(#paint1_linear_1477_4171)"
                strokeWidth="5"
            />
            {channel === Channel.AliceSkill ? (
                <g clipPath="url(#clip1_1477_4171)">
                    <path
                        d="M28.2184 61.9423C31.3197 65.0283 39.5807 66.8814 47.9998 66.9139C56.4187 66.8814 64.6799 65.0283 67.7812 61.9423C75.4864 54.2751 56.7566 24.9005 48.0095 24.8578C39.2431 24.9005 20.5133 54.2751 28.2184 61.9423Z"
                        fill="white"
                    />
                </g>
            ) : (
                <path
                    d="M67.5624 42.2404C66.6892 41.1224 65.6833 40.115 64.567 39.2404L55.1166 30.9904C52.6005 28.7854 51.3424 27.6904 49.9346 27.2704C48.692 26.9104 47.373 26.9104 46.1305 27.2704C44.7226 27.6904 43.4646 28.7704 40.9485 30.9904L31.528 39.2404C30.4117 40.115 29.4058 41.1224 28.5326 42.2404C28.0066 43.006 27.6212 43.8593 27.3944 44.7604C27.0969 46.175 26.9762 47.621 27.0349 49.0654V55.8454C27.0349 59.4004 27.0349 61.1704 27.7089 62.5354C28.3088 63.7207 29.2612 64.6903 30.4347 65.3104C31.7676 66.0004 33.5199 66.0004 37.0095 66.0004H58.9956C62.4852 66.0004 64.2375 66.0004 65.5705 65.3104C66.7439 64.6903 67.6963 63.7207 68.2962 62.5354C68.9702 61.1704 68.9702 59.4004 68.9702 55.8454V49.0654C69.0585 47.6248 68.968 46.1787 68.7006 44.7604C68.4738 43.8593 68.0884 43.006 67.5624 42.2404Z"
                    fill="white"
                />
            )}
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_1477_4171"
                x1="1.78814e-07"
                y1="48"
                x2="96"
                y2="48"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8A6BFF" />
                <stop offset="1" stopColor="#75C6FF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1477_4171"
                x1="1.78814e-07"
                y1="48"
                x2="96"
                y2="48"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8A6BFF" />
                <stop offset="1" stopColor="#75C6FF" />
            </linearGradient>
            <clipPath id="clip0_1477_4171">
                <rect width="96" height="96" fill="white" />
            </clipPath>
            <clipPath id="clip1_1477_4171">
                <rect width="96" height="96" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
